



 export const localRouter_meun_invest = [ //产业招商大脑导航栏顺序
    //工作台
{
    code: "E",
    switch: true,
    name: "",
    oldtext: "投资项目库检索",
    type: "ndjs",
    url: "/investSearch",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "B",
    switch: true,
    name: "",
    oldtext: "上市公司投资监测",
    type: "pxm",
    url: "/investMonitor",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
//个人中心
{
    code: "H",
    switch: true,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: []
},
]
 